/* ============================================================
   COLLECTION AKHAVAN — Main JS
   ============================================================ */

(function () {
  'use strict';

  /* ---- Mode toggle ---- */
  const body = document.body;
  const modeCapsule = document.getElementById('modeCapsule');
  const modeIcon    = document.getElementById('modeIcon');

  function applyMode(light) {
    body.classList.toggle('ak-light', light);
    // Keep <html> in sync with <body>. The inline <head> script sets `html.ak-light`
    // pre-paint to avoid a mode flash on navigation; without this toggle, switching
    // back to night would leave html.ak-light behind and keep the light variables.
    document.documentElement.classList.toggle('ak-light', light);
    localStorage.setItem('akhavan-mode', light ? 'light' : 'dark');
    renderModeIcon(light);
    if (modeCapsule) modeCapsule.title = light ? 'Switch to Night mode' : 'Switch to Day mode';
  }

  function renderModeIcon(light) {
    if (!modeIcon) return;
    modeIcon.innerHTML = light
      ? `<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>`
      : `<svg viewBox="0 0 24 24"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>`;
  }

  const savedMode = localStorage.getItem('akhavan-mode');
  applyMode(savedMode === 'light');

  if (modeCapsule) {
    modeCapsule.addEventListener('click', () => applyMode(!body.classList.contains('ak-light')));
  }

  /* ---- Footer drawers — always wired, CSS controls collapse on mobile ---- */
  document.querySelectorAll('.footer__col-title').forEach(function(title) {
    const parent = title.parentElement;
    const content = parent.querySelector('.footer__links, .footer__address');
    if (!content) return;
    parent.classList.add('footer__drawer');
    title.classList.add('footer__drawer-toggle');
    title.addEventListener('click', function() {
      const isOpen = parent.classList.contains('open');
      if (isOpen) {
        content.style.maxHeight = content.scrollHeight + 'px';
        requestAnimationFrame(function() {
          content.style.maxHeight = '0';
        });
        parent.classList.remove('open');
      } else {
        parent.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
        content.addEventListener('transitionend', function clear(e) {
          /* Only finalize on the height animation — the opacity transition
             finishes earlier and would snap the panel open mid-glide. */
          if (e.propertyName !== 'max-height') return;
          if (parent.classList.contains('open')) content.style.maxHeight = 'none';
          content.removeEventListener('transitionend', clear);
        });
      }
    });
  });

  /* ---- Language toggle ----
     Handled server-side now: `ak-lang-switch.liquid` posts to Shopify's
     /localization endpoint and the active button is marked from
     `localization.language`. No client-side state to keep in sync. */

  /* ---- Scroll: header state ---- */
  const header = document.querySelector('.header');
  if (header && !header.classList.contains('solid')) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Panel system ---- */
  const overlay    = document.getElementById('overlay');
  const menuPanel  = document.getElementById('menuPanel');
  const resPanel   = document.getElementById('reservePanel');

  /* Width of the vertical scrollbar / reserved gutter, exposed as --sbw so the
     panel-open logic can compensate for it when the gutter collapses (see
     .ak-scroll-lock in ak-styles.css). Measured only while UNLOCKED, when the
     gutter is actually reserved; 0 on overlay-scrollbar platforms → no-op. */
  function measureScrollbar() {
    if (document.documentElement.classList.contains('ak-scroll-lock')) return;
    const sbw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--sbw', Math.max(0, sbw) + 'px');
  }
  measureScrollbar();
  window.addEventListener('resize', measureScrollbar);

  let unlockTimer = null;

  function lockScroll(on) {
    const html = document.documentElement;
    if (on) {
      if (unlockTimer) { clearTimeout(unlockTimer); unlockTimer = null; }
      measureScrollbar();                    // refresh --sbw before the gutter collapses
      html.classList.add('ak-scroll-lock');  // collapse gutter + compensate → no jump
      /* Grow the hero on the NEXT frame so its pre-grow width is committed first
         and the CSS width transition actually runs (rather than snapping). */
      requestAnimationFrame(function () { html.classList.add('ak-hero-cover'); });
    } else {
      html.classList.remove('ak-hero-cover');  // hero smoothly shrinks back...
      /* ...keep scroll locked until it finishes, THEN restore the scrollbar, so
         closing doesn't snap the hero (and page) sideways. Re-checked in case a
         panel was reopened mid-shrink. */
      if (unlockTimer) clearTimeout(unlockTimer);
      unlockTimer = setTimeout(function () {
        unlockTimer = null;
        if (!document.querySelector('.menu-panel.open, .reserve-panel.open')) {
          html.classList.remove('ak-scroll-lock');
        }
      }, 380);
    }
  }

  /* The Cal.com embed lives in an iframe that keeps its own state. Closing the
     panel only hides it with CSS, so a completed booking's success page (or a
     half-filled form) persists across reopens. Rather than wipe it on every
     open — which would throw away an in-progress selection — we let the user
     reset on demand via the reset button in the panel head. Reassigning the
     iframe src forces a reload back to the fresh calendar (works cross-origin —
     we only set the attribute, never read the contents). */
  function reloadCalEmbeds() {
    document.querySelectorAll('#my-cal-dark iframe, #my-cal-light iframe')
      .forEach(f => { f.src = f.src; });
  }

  function openPanel(el) {
    if (!el) return;
    el.classList.add('open');
    overlay && overlay.classList.add('visible');
    lockScroll(true);
  }

  function closePanel(el) {
    if (!el) return;
    el.classList.remove('open');
    const still = document.querySelector('.menu-panel.open, .reserve-panel.open');
    if (!still) {
      overlay && overlay.classList.remove('visible');
      lockScroll(false);
    }
  }

  function closeAll() {
    document.querySelectorAll('.menu-panel, .reserve-panel').forEach(p => p.classList.remove('open'));
    overlay && overlay.classList.remove('visible');
    lockScroll(false);
  }

  /* Hamburger open */
  document.getElementById('menuOpen')?.addEventListener('click', () => openPanel(menuPanel));
  document.getElementById('menuClose')?.addEventListener('click', () => closePanel(menuPanel));

  /* Reserve open — delegated so it catches dynamically-added [data-reserve] elements */
  document.addEventListener('click', e => {
    if (e.target.closest('[data-reserve]')) {
      closePanel(menuPanel);
      openPanel(resPanel);
    }
  });

  document.getElementById('reserveClose')?.addEventListener('click', () => closePanel(resPanel));

  /* Reset button — reload the embed back to a fresh calendar on demand */
  document.getElementById('reserveReset')?.addEventListener('click', reloadCalEmbeds);

  /* Overlay + Escape */
  overlay?.addEventListener('click', closeAll);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });

  /* ---- Scroll reveal ---- */
  const revEls = document.querySelectorAll('.reveal');
  if (revEls.length) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });
    revEls.forEach(el => io.observe(el));
    /* Reveal elements already in viewport on load */
    const triggerVisible = () => {
      revEls.forEach(el => {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) {
          el.classList.add('in');
          io.unobserve(el);
        }
      });
    };
    requestAnimationFrame(triggerVisible);
    setTimeout(triggerVisible, 120);
  }

  /* ---- Location parallax photo strip ---- */
  const locStrip = document.getElementById('locPhotosStrip');
  const locTrack = document.getElementById('locPhotosTrack');
  if (locStrip && locTrack) {
    let isDragging = false;
    let dragX = 0;
    let dragShift = 0;

    function getMaxShift() {
      return -(locTrack.scrollWidth - locStrip.offsetWidth);
    }
    function clampShift(v) {
      return Math.max(getMaxShift(), Math.min(0, v));
    }
    function getCurrentShift() {
      const m = locTrack.style.transform.match(/-?\d+\.?\d*/);
      return m ? parseFloat(m[0]) : 0;
    }

    function updateLocParallax() {
      if (isDragging) return;
      const rect = locStrip.getBoundingClientRect();
      const winH = window.innerHeight;
      const progress = (winH / 2 - (rect.top + rect.height / 2)) / (winH + rect.height);
      const clamped = Math.max(-0.5, Math.min(0.5, progress));
      locTrack.style.transform = 'translateX(' + ((clamped + 0.5) * getMaxShift()) + 'px)';
    }
    window.addEventListener('scroll', updateLocParallax, { passive: true });
    updateLocParallax();

    /* Mouse drag */
    locStrip.addEventListener('mousedown', function(e) {
      isDragging = true;
      dragX = e.clientX;
      dragShift = getCurrentShift();
      e.preventDefault();
    });
    window.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      const dx = e.clientX - dragX;
      dragX = e.clientX;
      dragShift = clampShift(dragShift + dx);
      locTrack.style.transform = 'translateX(' + dragShift + 'px)';
    });
    window.addEventListener('mouseup', function() {
      isDragging = false;
    });

    /* Touch swipe (touch screens) */
    locStrip.addEventListener('touchstart', function(e) {
      isDragging = true;
      dragX = e.touches[0].clientX;
      dragShift = getCurrentShift();
    }, { passive: true });
    locStrip.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      const dx = e.touches[0].clientX - dragX;
      dragX = e.touches[0].clientX;
      dragShift = clampShift(dragShift + dx);
      locTrack.style.transform = 'translateX(' + dragShift + 'px)';
    }, { passive: true });
    locStrip.addEventListener('touchend', function() {
      isDragging = false;
    });

    /* Trackpad / mousewheel horizontal swipe */
    var wheelTimer;
    locStrip.addEventListener('wheel', function(e) {
      if (Math.abs(e.deltaX) < 2) return;
      e.preventDefault();
      isDragging = true;
      dragShift = clampShift(getCurrentShift() - e.deltaX);
      locTrack.style.transform = 'translateX(' + dragShift + 'px)';
      clearTimeout(wheelTimer);
      wheelTimer = setTimeout(function() { isDragging = false; }, 200);
    }, { passive: false });
  }

  /* ---- Number steppers (custom spinner arrows) ---- */
  document.querySelectorAll('[data-stepper]').forEach(function(wrap) {
    const input = wrap.querySelector('input[type="number"]');
    if (!input) return;
    wrap.querySelectorAll('[data-step]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const dir  = btn.getAttribute('data-step') === 'down' ? -1 : 1;
        const step = parseFloat(input.step) || 1;
        const hasMin = input.min !== '';
        const hasMax = input.max !== '';
        const min = hasMin ? parseFloat(input.min) : -Infinity;
        const max = hasMax ? parseFloat(input.max) :  Infinity;
        let val = parseFloat(input.value);
        if (isNaN(val)) {
          /* Empty field: first press snaps to the nearest bound */
          val = dir > 0 ? (hasMin ? min : 0) : (hasMax ? max : 0);
        } else {
          val += dir * step;
        }
        input.value = Math.min(max, Math.max(min, val));
        input.dispatchEvent(new Event('input',  { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* Exhibition detail content is rendered server-side by the ak-exhibition-detail section. */

})();
